import React from 'react';
import { Github, FileText, BarChart3, Users, Code } from 'lucide-react';
import { getStatusColor } from '../utils/helpers';

const ProjectCard = ({ project }) => {
  return (
    <div className="group bg-gray-900/50 border border-green-500/30 rounded-xl overflow-hidden hover:border-green-500/60 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/10 backdrop-blur-sm">
      <div className="relative overflow-hidden bg-gray-800 h-48">
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" />
        <div className="absolute top-4 right-4">
          <span className={`px-3 py-1 border text-xs font-mono rounded ${getStatusColor(project.status)}`}>
            {project.status}
          </span>
        </div>
        <div className="absolute bottom-4 left-4">
          <span className="px-3 py-1 bg-gray-800/90 backdrop-blur-sm text-gray-300 text-xs font-mono rounded">
            {project.type}
          </span>
        </div>
      </div>

      <div className="p-8">
        <div className="flex items-start justify-between mb-4">
          <div className="text-green-400">
            <project.icon className="w-8 h-8" />
          </div>
          <div className="flex items-center gap-1 text-gray-400 text-sm">
            <BarChart3 className="w-4 h-4" />
            <span className="font-mono">{project.impact}</span>
          </div>
        </div>
        
        <h3 className="text-xl font-bold text-white mb-3 font-mono">{project.title}</h3>
        <p className="text-gray-300 mb-6 leading-relaxed">{project.description}</p>
        
        <div className="flex flex-wrap gap-2 mb-6">
          {project.tech.map((tech) => (
            <span key={tech} className="px-3 py-1 bg-green-500/10 border border-green-500/30 text-green-400 text-sm rounded font-mono">
              {tech}
            </span>
          ))}
        </div>
        
        <div className="flex items-center gap-4 mb-6 text-sm text-gray-400">
          <span className="flex items-center gap-1">
            <Users className="w-4 h-4" />
            Enterprise Ready
          </span>
          <span className="flex items-center gap-1">
            <Code className="w-4 h-4" />
            {project.version}
          </span>
        </div>
        
        <div className="flex gap-4">
          <a href={project.github} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-green-400 transition-colors font-mono text-sm">
            <Github className="w-4 h-4" />
            RESOURCES
          </a>
          <a href={project.demo} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors font-mono text-sm">
            <FileText className="w-4 h-4" />
            DOCUMENTATION
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;